import { useContentfulFetch } from '@/composables/useContentfulFetch'

export const useSolutionsPage = async () => {
  const { locale } = useI18n()

  const key = `page-solutions-${locale.value}`

  const { data: content } = await useAsyncData(key, async () => {
    try {
      return await useContentfulFetch({
        url: '/api/v1/contentful/content',
        query: {
          contentModelOptions: {
            adapter: 'pageData',
            route: '/rozwiazania',
          },
        },
      })
    }
    catch (e) {
      console.error(e)
      return { content: null }
    }
  })
  return { content }
}
